import * as resultOfConsiderType from './resultOfConsiderType'
import useResultOfConsider from './useResultOfConsider'
import MyAccordion from '../../../../../control/accordion/accordion'
import RichTextEditor from '../../../../../control/richTextEditor/richTextEditor'
import { Grid, useTheme, makeStyles } from '@material-ui/core'
import { Form } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import { FieldArray } from 'react-final-form-arrays'
import useTranslate from '../../../../../i18n/useTranslate'
import PageAction from '../pageAction'
import Button from '../../../../../control/button/button'
import useCheckPermission from '../../../../../utilities/checkPermission'
import useSnackbarAction from '../../../../../stores/snackbar/snackbarAction'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Dialog from '../../../../../control/dialog/dialog'

import constProjectStatus from '../../../../../constants/projectStatus'
import { approveStatusREC1, approveStatusREC2 } from '../../../../../constants/approveStatus'

const ResultOfConsiderView: React.FC<resultOfConsiderType.ResultOfConsiderViewType> = (props) => {
    const {
        initialValues,
        approveStatus,
        projectData,
        initialComment,
        initialRichTextEditor,
        // documentInfoList,
        initialRichRemark,
        // handleDirtyChange,
        onClickCancel,
        onSubmitForm,
        configDialog,
        onRefDialog,
        isViewMode,
        // isHideDocumentCertificate = false,
        isFlowApproveWithComment = false,
    } = props

    const translate = useTranslate()
    const checkPermission = useCheckPermission()
    const snackbarAction = useSnackbarAction()
    const classes = useStyles()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))

    const isAdmin = checkPermission.isUserAdmin()
    // const isShowCommentRemarkList = initialValues?.commentRemarkList !== null

    const isShowComment =
        approveStatus &&
        approveStatus?.id !== approveStatusREC1.approve &&
        approveStatus?.id !== approveStatusREC2.approve &&
        approveStatus?.id !== approveStatusREC1.approveForContiueResearch &&
        approveStatus?.id !== approveStatusREC2.approveForContiueResearch //ผลการพิจารณาเป็นไม่ใช่อนุมัติและไม่ใช่อนุมัติให้ดำเนินการวิจัยต่อเนื่อง จะโชว์คอมเม้นเป็นหัวข้อ ถ้าเป็นอนุมัติและ อนุมัติให้ดำเนินการวิจัยต่อเนื่องจะโชว์แค่ผลไม่โชว์คอมเม้น

    const isStatusComplete = projectData && projectData?.projectStatusInfo?.value === constProjectStatus.completed
    const isShowCloseProjectButton = isStatusComplete && isAdmin

    const renderResearcherView = (name: string, index: number) => {
        return (
            <>
                <Grid item xs={12} md={12} lg={12}>
                    <RichTextEditor
                        name={`${name}.consideration`}
                        initialRichTextEditor={initialRichTextEditor[index]}
                        disabled={isViewMode}
                        isHideToolbar={true}
                        label={
                            initialComment[index]?.no
                                ? `${initialComment[index]?.no}. ${initialComment[index]?.topic}`
                                : translate.get('LABEL.SUGGESTION_NOTICE')
                        }
                    />
                </Grid>
            </>
        )
    }

    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{ ...initialValues, commentDirector: initialComment }}
            keepDirtyOnReinitialize={true}
            mutators={{
                ...arrayMutators,
            }}
        >
            {(props) => {
                const { form, handleSubmit, dirty, invalid, errors, values } = props

                return (
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <MyAccordion title={translate.get('LABEL.RESOLUTION')}>
                                    <Grid container item justify="flex-start" spacing={2}>
                                        <Grid item xs={12} md={12} lg={12}>
                                            <Grid item xs={12} md={12} lg={12}>
                                                <RichTextEditor
                                                    name="remark"
                                                    initialRichTextEditor={initialRichRemark}
                                                    disabled={isViewMode}
                                                    isHideToolbar={isViewMode}
                                                    // label={translate.get('LABEL.ETHIC_REVIEW_OUTCOME')}
                                                    maxLength={2000}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </MyAccordion>
                            </Grid>
                            {!isFlowApproveWithComment && (
                                <Grid item xs={12}>
                                    <MyAccordion title={translate.get('LABEL.NOTIFY_REVIEW_OUTCOME')}>
                                        <Grid container item justify="flex-start" spacing={2}>
                                            <Grid item xs={12} md={12} lg={12}>
                                                {translate.get('LABEL.ETHIC_REVIEW_OUTCOME')} :{' '}
                                                {approveStatus?.id === approveStatusREC1.approveWithComment ||
                                                approveStatus?.id === approveStatusREC2.approveWithComment
                                                    ? translate.get('LABEL.APPROVE')
                                                    : translate.languageStore.currentLanguage ===
                                                      translate.languageKey.th
                                                    ? approveStatus?.nameTH
                                                    : approveStatus?.nameEN}
                                            </Grid>

                                            {isShowComment && (
                                                <FieldArray name="commentDirector">
                                                    {({ fields }) => {
                                                        return fields?.map((name, index) =>
                                                            renderResearcherView(name, index),
                                                        )
                                                    }}
                                                </FieldArray>
                                            )}
                                        </Grid>
                                    </MyAccordion>
                                </Grid>
                            )}

                            {/* {!isFlowApproveWithComment && (
                                <Grid item xs={12}>
                                    <MyAccordion title={translate.get('LABEL.REMARK')}>
                                        <Grid container item justify="flex-start" spacing={2}>
                                            {!isResearcherView ? (
                                                <Grid item xs={12} md={12} lg={12}>
                                                    {isShowCommentRemarkList && (
                                                        <Grid item xs={12} md={12} lg={12}>
                                                            <MyTextfield
                                                                name="commentRemarkList"
                                                                materialInputProps={{
                                                                    disabled: true,
                                                                    label: '',
                                                                    size: 'small',
                                                                    rows: 5,
                                                                    multiline: true,
                                                                }}
                                                                // required
                                                            />
                                                        </Grid>
                                                    )}

                                                    <Grid item xs={12} md={12} lg={12}>
                                                        <RichTextEditor
                                                            name="remark"
                                                            initialRichTextEditor={initialRichRemark}
                                                            disabled={isViewMode}
                                                            isHideToolbar={isViewMode}
                                                            // label={translate.get('LABEL.ETHIC_REVIEW_OUTCOME')}
                                                            maxLength={2000}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            ) : (
                                                <Grid item xs={12} md={12} lg={12}>
                                                    <RichTextEditor
                                                        name="remark"
                                                        initialRichTextEditor={initialRichRemark}
                                                        disabled={true} //{isViewMode}
                                                        isHideToolbar={true}
                                                        // label={translate.get('LABEL.ETHIC_REVIEW_OUTCOME')}
                                                        maxLength={2000}
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                    </MyAccordion>
                                </Grid>
                            )} */}
                        </Grid>
                        {!isViewMode ? (
                            <Grid item xs={12}>
                                <PageAction
                                    onClickClose={() => {
                                        onClickCancel(dirty)
                                    }}
                                    onClickSave={() => {
                                        form.change('submitType', 'save')
                                        handleSubmit()
                                        invalid &&
                                            errors &&
                                            snackbarAction.openSnackbar({
                                                message: translate.get('MESSAGE.M012'),
                                                type: 'error',
                                            })
                                    }}
                                    onClickSaveDraft={() => {
                                        form.change('submitType', 'draft')
                                        handleSubmit()
                                    }}
                                />
                            </Grid>
                        ) : (
                            <Grid container item xs={12} md={12} lg={12} justify={'flex-end'}>
                                {isShowCloseProjectButton && (
                                    <Grid
                                        container
                                        item
                                        xs={12}
                                        sm={10}
                                        md={10}
                                        lg={10}
                                        xl={10}
                                        justify={'flex-start'}
                                        className={classes.spacingButton}
                                    >
                                        <Button
                                            color="inherit"
                                            // onClick={onClickCloseProject}
                                            fullWidth={isMobileView ? true : false}
                                            style={{
                                                backgroundColor: 'red',
                                                border: 'solid 1px #db5f8e',
                                                color: '#FFFFFF',
                                            }}
                                        >
                                            {translate.get('BUTTON.CLOSE_PROJECT')}
                                        </Button>
                                    </Grid>
                                )}
                            </Grid>
                        )}
                        <Dialog onRef={onRefDialog} {...configDialog} />
                        {/* <FormSpy subscription={{ dirty: true, values: true }} onChange={handleDirtyChange} /> */}
                    </>
                )
            }}
        </Form>
    )
}

const ResultConsider: React.FC<resultOfConsiderType.ResultOfConsiderType> = (props) => {
    const useResultOfConsiderModel = useResultOfConsider(props)
    return <ResultOfConsiderView {...useResultOfConsiderModel} {...props} />
}
const useStyles = makeStyles((theme) => ({
    spacingButton: {
        marginBottom: '10px',
    },
    paper: {
        width: '100%',
        height: 128,
        padding: 20,
    },
    titleFont: {
        color: '#BDBDBD',
    },
    contentFont: {
        fontWeight: 'bold',
    },
}))

export default ResultConsider
